import { Container, Item } from './styled';

export const SelectCheckbox = ({ options = [], value, onChange }) => {
  return (
    <Container>
      {options.map(option => (
        <Item key={option.value}>
          <label>
            <input type="checkbox" checked={value === option.value} onChange={() => onChange(option.value)} />
            {option.label}
          </label>
        </Item>
      ))}
    </Container>
  );
};
